import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatHours } from '../../utilities/timeUtility';

export default class TimeSlot extends Component {
  render() {
    const {
      style,
      disabled,
      className,
      onClick,
      locale,
      timeZone,
      start,
      finish,
      isDisplayRange,
      isShowRemainingSpace,
      availableSpace,
      timeFormat,
    } = this.props;

    const title = availableSpace > 0 ? availableSpace : 'No';

    return (
      <div style={style} disabled={disabled} className={className} onClick={onClick}>
        <p className="fz13 bold m5 uppercase">
          {formatHours(start, locale, timeZone, timeFormat)}
          {isDisplayRange && ` - ${formatHours(finish, locale, timeZone, timeFormat)}`}
        </p>
        {isShowRemainingSpace && <p className="m5">{`${title} space available`}</p>}
      </div>
    );
  }
}

TimeSlot.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  start: PropTypes.object,
  finish: PropTypes.object,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  timeFormat: PropTypes.string,
  availableSpace: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
